import { render } from "./Pfadfinder.vue?vue&type=template&id=58746a24"
import script from "./Pfadfinder.vue?vue&type=script&lang=js"
export * from "./Pfadfinder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__